import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'chart.js';
import { Apollo, QueryRef, gql } from 'apollo-angular';
//servicios
import { DocumentoService } from 'src/app/services/documento.service';
import { ContratistaService } from 'src/app/services/contratista.service';
import { LoginService } from 'src/app/services/login.service';
import { GestorService } from 'src/app/services/gestor.service';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';

@Component({
  selector: 'app-inicio-inproeco',
  templateUrl: './inicio-inproeco.component.html',
  styleUrls: ['./inicio-inproeco.component.scss']
})
export class InicioInproecoComponent implements OnInit {

  @ViewChild('doughnutCanvas') doughnutCanvas: any;

  title = 'Documentos';
  barChart: any;
  doughnutChart: any;
  lineChart: any;
  loading: any
  documentos:any
  docPendientes:any
  documentoAdic:any =[]

  constructor(private router: Router, private apollo: Apollo,private contratistaService: ContratistaService, private loginservice: LoginService,
    private documentoService: DocumentoService, private docAdicService: DocAdicionalService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
   
    this.getAllDocumentos()
    this.getAllDocumentosAdicionalesSinValidar()
    setTimeout(() => {
      this.setIndicadores()
    }, 3000);
  }

  getAllDocumentos(){
    this.apollo.watchQuery<any>({
      query: this.documentoService.getAllDocumentosValidados(),
      fetchPolicy: 'no-cache',
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        this.documentos = data.documentos
        /* console.log(this.documentos) */
        const documentosActivos = this.documentos.filter((documento: any) => 
          documento.tipo === 'haciendaActivo' || documento.tipo === 'seguridadSocialActivo' || documento.tipo === 'activo'
          ||  documento.tipo === 'haciendaActivoEnEspera' ||  documento.tipo === 'seguridadSocialActivoEnEspera' || documento.tipo === 'enEspera')

        /* console.log(documentosActivos) */
        const docCaducado = documentosActivos.filter((doc:any)=> doc.caducado)
        const docEnFecha = documentosActivos.filter((doc:any)=> doc.enFecha);
        const docProxCaduca = documentosActivos.filter((doc:any)=> doc.proximoCaduca);
       /*  console.log(docCaducado) */
        const dataDocumentos= [Object.keys(docEnFecha).length, Object.keys(docProxCaduca).length, Object.keys(docCaducado).length]
        this.doughnutChartMethod(dataDocumentos);

        /* const pendiente = this.documentos.filter((documento: any) => 
          documento.tipo === 'haciendaPendiente' || documento.tipo === 'seguridadSocialPendiente' || documento.tipo === 'pendiente')
        console.log(pendiente)

        this.docPendientes = pendiente.length
        console.log(this.docPendientes) */


      })
  }

  getAllDocumentosAdicionalesSinValidar(){
    this.apollo.watchQuery<any>({
      query: this.docAdicService.getAllDocumentosSinValidar(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data);
        
        this.documentoAdic = data.documentosAdicionals
        this.getAllDocumentosSinValidar()
      })
  }

  getAllDocumentosSinValidar(){
    this.apollo.watchQuery<any>({
      query: this.documentoService.getAllDocumentosSinValidar(),
      fetchPolicy: 'no-cache',
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.loading = loading
        this.documentos = data.documentos
        this.documentoAdic.forEach((doc:any) => {
          this.documentos.push(doc)
        });
        
        /* console.log(this.documentos) */
        const pendiente = this.documentos.filter((documento: any) => 
          documento.tipo === 'haciendaPendiente' || documento.tipo === 'seguridadSocialPendiente' || documento.tipo === 'pendiente')
        /* console.log(pendiente) */

        this.docPendientes = pendiente.length
        
        /* console.log(this.docPendientes) */


      })
  }
  
  doughnutChartMethod(data:any) {
    this.doughnutChart = new Chart(this.doughnutCanvas.nativeElement, {
      type: 'doughnut',
     
      data: {
       labels: ['Correcto', 'Próximo a caducar', 'Caducado'],    
        datasets: [{
          label: 'licencias',
          data: data,
          backgroundColor: [
            '#00A131',
            '#FF9E00',
            '#DC3737'
          ],
    
         hoverBackgroundColor: [
              '#308F70',
              '#EDB355',
              '#EE5B5B'
            ]
        }],
      },
       options: {
        tooltips: {enabled: true},
     } 
    });
  }

/*   handleColorClick(e: Event){
    const slice = this.doughnutChart.getElementAtEvent(e)
    switch(slice[0]?._model.backgroundColor){
      case "rgb(255, 176, 41)":
        this.router.navigate(['inproeco/estado/documentacion-proxima'])
        break
      case "rgb(250, 0, 0)":
        this.router.navigate(['inproeco/estado/documentacion-caducada'])
        break
    }
	} */

  setIndicadores() {

    this.setDocumentoProximoCaduca()
    this.setDocumentoCaducado()
    this.setDocumentoEnFecha()


  }

  setDocumentoProximoCaduca() {
    this.documentos.map((documento: any) => {
    
      if (documento?.fechaCaducidad <= this.documentoService.getNextMonth() && documento?.fechaCaducidad > this.documentoService.getActualDate()) {
        this.updateDocumentoToProximoCaduca(documento?.id)
      }
    })
  }



  updateDocumentoToProximoCaduca(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "proximoCaduca": true,
            "caducado": false,
            "enFecha": false,
            "estado": "amarillo"
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

  setDocumentoCaducado() {
    this.documentos.map((documento: any) => {
      if (documento.fechaCaducidad <= this.documentoService.getActualDate()) {
        this.updateDocumentoToCaducado(documento.id)
      }
    })
  }

  updateDocumentoToCaducado(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": true,
            "proximoCaduca": false,
            "enFecha": false,
            "estado": "rojo"
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log(error)
      })
  }

  setDocumentoEnFecha() {
    this.documentos.map((documento: any) => {
      if (documento.fechaCaducidad > this.documentoService.getNextMonth() && documento.fechaCaducidad > this.documentoService.getActualDate()) {
        this.updateDocumentoToEnFecha(documento.id)
      } 
      if (documento.noCaduca) {
        this.updateDocumentoToEnFecha(documento.id)
      }
    })
  }

  updateDocumentoToEnFecha(id: string) {
    this.apollo.mutate({
      mutation: this.documentoService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
          "data": {
            "caducado": false,
            "proximoCaduca": false,
            "enFecha": true,
            "estado": "verde"
          }
        }
      }
    })
      .subscribe(({ data, errors }) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa', error)
      })
  }

}
